import { SelectOption } from 'src/components/input/Select';

export const generateBlockingHours = (): SelectOption[] => {
	const hours: SelectOption[] = Array.from({ length: 24 }, (_, i) => {
		const hour = i.toString().padStart(2, '0') + ':00';
		return { value: hour, label: hour };
	});

	// Push the last special case: value 23:59 but label 24:00
	hours.push({ value: '23:59', label: '24:00' });

	return hours;
};
